import { cva, type VariantProps } from "./style.utils";
import { textInputVariants } from "./text-input.styles";

export type TextareaVariants = VariantProps<typeof textareaVariants>;

export const textareaVariants = cva({
  composes: [textInputVariants],
  base: "align-top",
  variants: {
    size: {
      sm: "h-60px min-h-30px px-10px py-5px", // compact
      md: "h-72px min-h-36px px-12px py-6px", // convenient
      lg: "h-80px min-h-40px px-14px py-7px", // cozy
    },
  },
  defaultVariants: {
    size: "md",
  },
});
